import React from 'react';

const Note = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 12 16" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <path fill="#6f7070" d="M12 2.003v13.334H0V2.003h3.9a2.32 2.32 0 0 1 4.2 0zM2 13.348h8V4.001H2zM3.333 6h3.344v2.008H3.333zm0 3.33h5.344v2.01H3.333z"/>
  </svg>
);

export default Note;



// WEBPACK FOOTER //
// ./src/common/icons/Note.js